import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import styles from './Form.module.scss';
export const Form = (param)=>{
    let { children, className, testId, id, onSubmit, layoutTransparent } = param;
    return /*#__PURE__*/ _jsx("form", {
        id: id,
        className: cn({
            [styles.layoutTransparent]: layoutTransparent
        }, className),
        onSubmit: onSubmit,
        "data-testid": testId,
        children: children
    });
};
